import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';
import { TripLegProviderNoteType } from '../../data/models/note.model';
import * as providerSlice from '../../data/provider.slice';

interface IProviderNoteDetail {
  transportationProviderID: number;
  transportationProviderNoteID: string;
  note: TripLegProviderNoteType;
}

interface IProviderNoteCommentDetail {
  transportationProviderID: number;
  transportationProviderNoteID: string;
  noteComment: TripLegProviderNoteType;
}

enum ProviderNoteEventType {
  ProviderNoteCreated = 'ProviderNoteCreated',
  ProviderNoteDeleted = 'ProviderNoteDeleted',
  ProviderNoteUpdated = 'ProviderNoteUpdated',
  ProviderNoteCommentCreated = 'ProviderNoteCommentCreated',
  ProviderNoteCommentDeleted = 'ProviderNoteCommentDeleted',
  ProviderNoteCommentUpdated = 'ProviderNoteCommentUpdated',
}

/**
 * Method for handling all Internal Note Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegEventType enum values
 * @param detail An object containing the event data, in this case a TripLeg
 */
function updateProviderNote(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: IProviderNoteDetail & IProviderNoteCommentDetail,
) {
  switch (detailType) {
    case ProviderNoteEventType.ProviderNoteCreated:
    case ProviderNoteEventType.ProviderNoteUpdated:
      dispatch(providerSlice.upsertProviderNote(detail.note));
      break;
    case ProviderNoteEventType.ProviderNoteDeleted:
      dispatch(providerSlice.removeProviderNote(detail.note));
      break;
    case ProviderNoteEventType.ProviderNoteCommentCreated:
    case ProviderNoteEventType.ProviderNoteCommentDeleted:
    case ProviderNoteEventType.ProviderNoteCommentUpdated:
    default:
      break;
  }
}

export { ProviderNoteEventType, updateProviderNote };
